/** Title/subtitle: direct input wins, then config value. */
export function resolveCardTextField(
	direct: string | undefined,
	configValue: string | undefined | null,
	fallback = ''
): string {
	return direct ?? configValue ?? fallback;
}

/** Icon: direct input wins, then config value. */
export function resolveCardIconField(
	direct: string | undefined,
	configValue: string | undefined | null
): string | undefined {
	return direct ?? configValue ?? undefined;
}
